var DealWidgets;

DealWidgets = window.DealWidgets != null ? window.DealWidgets : window.DealWidgets = {};

DealWidgets.lazyLoadImages = function($widgets) {
  return $widgets.find('.lazy-load').each(function(position, imageElement) {
    var $image;
    $image = $(imageElement);
    return $image.attr('src', $image.attr('data-original'));
  });
};

DealWidgets.ajax_success = function(data, productReviews, done) {
  var $aboveReviewsSlot, $bottomSlot, $featuredTopSlot, $widgets, hasWidgets, ref, ref1, ref2, ref3, ref4;
  if (data == null) {
    $('#featuredtopslot-widget-placeholder').remove();
    $('#bottomslot-widget-placeholder').remove();
    $('#abovereviewsslot-widget-placeholder').remove();
    return done();
  }
  hasWidgets = false;
  $featuredTopSlot = $('#featuredtopslot-widget-placeholder');
  $bottomSlot = $('#bottomslot-widget-placeholder');
  $aboveReviewsSlot = $('#abovereviewsslot-widget-placeholder');
  if ((ref = data.FeaturedTopSlot) != null ? ref.length : void 0) {
    hasWidgets = true;
    if ((ref1 = window.payload) != null ? ref1.solidLine : void 0) {
      $featuredTopSlot.replaceWith(data.FeaturedTopSlot + "<hr id='top-slot-border'/>");
    } else {
      $featuredTopSlot.replaceWith(data.FeaturedTopSlot + "<hr class='dotted-border' id='top-slot-border'/>");
    }
  } else {
    $featuredTopSlot.remove();
  }
  if ((ref2 = data.BottomSlot) != null ? ref2.length : void 0) {
    hasWidgets = true;
    $bottomSlot.replaceWith(data.BottomSlot);
  } else {
    $bottomSlot.remove();
  }
  if ((ref3 = data.AboveReviewsSlot) != null ? ref3.length : void 0) {
    hasWidgets = true;
    $aboveReviewsSlot.replaceWith(data.AboveReviewsSlot);
  } else {
    $aboveReviewsSlot.remove();
  }
  if (hasWidgets) {
    if ((ref4 = Groupon.Utils) != null) {
      if (typeof ref4.lazyLoadImages === "function") {
        ref4.lazyLoadImages();
      }
    }
    if ($widgets = $('.mm-widget, .fake-wls-widget .widget-deals')) {
      DealWidgets.lazyLoadImages($widgets);
      GIG.Utils.truncateElements($widgets);
    }
  }
  return done();
};

DealWidgets.ajax_success_cards = function(data, productReviews, clientDealWidgets, done) {
  var $aboveReviewCard, $bottomCard, cardHtml, hasCards, hasLocal, isUserMaxExceeded, maxPurchaseLimit, ref;
  isUserMaxExceeded = clientDealWidgets.isUserMaxExceeded, maxPurchaseLimit = clientDealWidgets.maxPurchaseLimit;
  if (data == null) {
    $('#cards-above-reviews-placeholder').remove();
    $('#cards-bottom-placeholder').remove();
    return done();
  }
  $aboveReviewCard = $('#cards-above-reviews-placeholder');
  $bottomCard = $('#cards-bottom-placeholder');
  if ((data[0] != null) && $aboveReviewCard.length === 0 && $bottomCard.hasClass('local-cards') && !isUserMaxExceeded) {
    hasLocal = true;
    hasCards = true;
    cardHtml = data[0];
    if (data[1] != null) {
      cardHtml += "<br /> " + data[1];
    }
    $aboveReviewCard.remove();
    $bottomCard.html(cardHtml);
  } else if (data[0] != null) {
    hasCards = true;
    if (isUserMaxExceeded) {
      $aboveReviewCard.html(data[0].replace("{maxPurchaseLimit}", maxPurchaseLimit));
    } else {
      $aboveReviewCard.html(data[0]);
    }
  } else {
    $aboveReviewCard.remove();
  }
  if ((data[1] != null) && !hasLocal) {
    hasCards = true;
    $bottomCard.html(data[1]);
  } else if (!hasLocal) {
    $bottomCard.remove();
  }
  if (hasCards) {
    if ((ref = Groupon.Utils) != null) {
      if (typeof ref.lazyLoadImages === "function") {
        ref.lazyLoadImages();
      }
    }
    CardUI.init();
  }
  return done();
};

DealWidgets.init = function(arg, done) {
  var clientDealWidgets, productReviews;
  clientDealWidgets = arg.clientDealWidgets, productReviews = arg.productReviews;
  if (clientDealWidgets == null) {
    return done();
  }
  return $(function() {
    return DealContentLoader.addOnLoadHandler(function() {
      return $.ajax({
        url: clientDealWidgets.formattedUrl,
        dataType: 'json',
        success: function(data) {
          if (clientDealWidgets.isCardatronCard) {
            return DealWidgets.ajax_success_cards(data, productReviews, clientDealWidgets, done);
          } else {
            return DealWidgets.ajax_success(data, productReviews, done);
          }
        },
        error: function(err) {
          $('#featuredtopslot-widget-placeholder').remove();
          $('#bottomslot-widget-placeholder').remove();
          $('#abovereviewsslot-widget-placeholder').remove();
          $('#cards-above-reviews-placeholder').remove();
          $('#cards-bottom-placeholder').remove();
          return done();
        }
      });
    });
  });
};

module.exports = DealWidgets;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsX3dpZGdldC9mcm9udGVuZC9kZWFsX3dpZGdldHMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsX3dpZGdldC9mcm9udGVuZC9kZWFsX3dpZGdldHMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsV0FBQSxnQ0FBYyxNQUFNLENBQUMsY0FBUCxNQUFNLENBQUMsY0FBZTs7QUFRcEMsV0FBVyxDQUFDLGNBQVosR0FBNkIsU0FBQyxRQUFEO1NBQzNCLFFBQVEsQ0FBQyxJQUFULENBQWMsWUFBZCxDQUEyQixDQUFDLElBQTVCLENBQWlDLFNBQUMsUUFBRCxFQUFXLFlBQVg7QUFDL0IsUUFBQTtJQUFBLE1BQUEsR0FBUyxDQUFBLENBQUUsWUFBRjtXQUNULE1BQU0sQ0FBQyxJQUFQLENBQVksS0FBWixFQUFtQixNQUFNLENBQUMsSUFBUCxDQUFZLGVBQVosQ0FBbkI7RUFGK0IsQ0FBakM7QUFEMkI7O0FBSzdCLFdBQVcsQ0FBQyxZQUFaLEdBQTJCLFNBQUMsSUFBRCxFQUFPLGNBQVAsRUFBdUIsSUFBdkI7QUFDekIsTUFBQTtFQUFBLElBQU8sWUFBUDtJQUNFLENBQUEsQ0FBRSxxQ0FBRixDQUF3QyxDQUFDLE1BQXpDLENBQUE7SUFDQSxDQUFBLENBQUUsZ0NBQUYsQ0FBbUMsQ0FBQyxNQUFwQyxDQUFBO0lBQ0EsQ0FBQSxDQUFFLHNDQUFGLENBQXlDLENBQUMsTUFBMUMsQ0FBQTtBQUNBLFdBQU8sSUFBQSxDQUFBLEVBSlQ7O0VBTUEsVUFBQSxHQUFhO0VBQ2IsZ0JBQUEsR0FBbUIsQ0FBQSxDQUFFLHFDQUFGO0VBQ25CLFdBQUEsR0FBYyxDQUFBLENBQUUsZ0NBQUY7RUFDZCxpQkFBQSxHQUFvQixDQUFBLENBQUUsc0NBQUY7RUFFcEIsOENBQXVCLENBQUUsZUFBekI7SUFDRSxVQUFBLEdBQWE7SUFDYiwwQ0FBaUIsQ0FBRSxrQkFBbkI7TUFDRSxnQkFBZ0IsQ0FBQyxXQUFqQixDQUE2QixJQUFJLENBQUMsZUFBTCxHQUF1Qiw0QkFBcEQsRUFERjtLQUFBLE1BQUE7TUFHRSxnQkFBZ0IsQ0FBQyxXQUFqQixDQUE2QixJQUFJLENBQUMsZUFBTCxHQUF1QixrREFBcEQsRUFIRjtLQUZGO0dBQUEsTUFBQTtJQU9FLGdCQUFnQixDQUFDLE1BQWpCLENBQUEsRUFQRjs7RUFTQSwyQ0FBa0IsQ0FBRSxlQUFwQjtJQUNFLFVBQUEsR0FBYTtJQUNiLFdBQVcsQ0FBQyxXQUFaLENBQXdCLElBQUksQ0FBQyxVQUE3QixFQUZGO0dBQUEsTUFBQTtJQUlFLFdBQVcsQ0FBQyxNQUFaLENBQUEsRUFKRjs7RUFNQSxpREFBd0IsQ0FBRSxlQUExQjtJQUNFLFVBQUEsR0FBYTtJQUNiLGlCQUFpQixDQUFDLFdBQWxCLENBQThCLElBQUksQ0FBQyxnQkFBbkMsRUFGRjtHQUFBLE1BQUE7SUFJRSxpQkFBaUIsQ0FBQyxNQUFsQixDQUFBLEVBSkY7O0VBTUEsSUFBRyxVQUFIOzs7WUFDZSxDQUFFOzs7SUFHZixJQUFHLFFBQUEsR0FBVyxDQUFBLENBQUUsNENBQUYsQ0FBZDtNQUNFLFdBQVcsQ0FBQyxjQUFaLENBQTJCLFFBQTNCO01BQ0EsR0FBRyxDQUFDLEtBQUssQ0FBQyxnQkFBVixDQUEyQixRQUEzQixFQUZGO0tBSkY7O1NBUUEsSUFBQSxDQUFBO0FBekN5Qjs7QUEyQzNCLFdBQVcsQ0FBQyxrQkFBWixHQUFpQyxTQUFDLElBQUQsRUFBTyxjQUFQLEVBQXVCLGlCQUF2QixFQUEwQyxJQUExQztBQUMvQixNQUFBO0VBQUMsdURBQUQsRUFBb0I7RUFDcEIsSUFBTyxZQUFQO0lBQ0UsQ0FBQSxDQUFFLGtDQUFGLENBQXFDLENBQUMsTUFBdEMsQ0FBQTtJQUNBLENBQUEsQ0FBRSwyQkFBRixDQUE4QixDQUFDLE1BQS9CLENBQUE7QUFDQSxXQUFPLElBQUEsQ0FBQSxFQUhUOztFQUtBLGdCQUFBLEdBQW1CLENBQUEsQ0FBRSxrQ0FBRjtFQUNuQixXQUFBLEdBQWMsQ0FBQSxDQUFFLDJCQUFGO0VBRWQsSUFBRyxpQkFBQSxJQUFhLGdCQUFnQixDQUFDLE1BQWpCLEtBQTJCLENBQXhDLElBQThDLFdBQVcsQ0FBQyxRQUFaLENBQXFCLGFBQXJCLENBQTlDLElBQXNGLENBQUksaUJBQTdGO0lBQ0UsUUFBQSxHQUFXO0lBQ1gsUUFBQSxHQUFXO0lBRVgsUUFBQSxHQUFXLElBQUssQ0FBQSxDQUFBO0lBQ2hCLElBQXFDLGVBQXJDO01BQUEsUUFBQSxJQUFZLFNBQUEsR0FBVyxJQUFLLENBQUEsQ0FBQSxFQUE1Qjs7SUFFQSxnQkFBZ0IsQ0FBQyxNQUFqQixDQUFBO0lBQ0EsV0FBVyxDQUFDLElBQVosQ0FBaUIsUUFBakIsRUFSRjtHQUFBLE1BU0ssSUFBRyxlQUFIO0lBQ0gsUUFBQSxHQUFXO0lBQ1gsSUFBRyxpQkFBSDtNQUNFLGdCQUFnQixDQUFDLElBQWpCLENBQXNCLElBQUssQ0FBQSxDQUFBLENBQUUsQ0FBQyxPQUFSLENBQWdCLG9CQUFoQixFQUFzQyxnQkFBdEMsQ0FBdEIsRUFERjtLQUFBLE1BQUE7TUFHRSxnQkFBZ0IsQ0FBQyxJQUFqQixDQUFzQixJQUFLLENBQUEsQ0FBQSxDQUEzQixFQUhGO0tBRkc7R0FBQSxNQUFBO0lBT0gsZ0JBQWdCLENBQUMsTUFBakIsQ0FBQSxFQVBHOztFQVNMLElBQUcsaUJBQUEsSUFBYSxDQUFJLFFBQXBCO0lBQ0UsUUFBQSxHQUFXO0lBQ1gsV0FBVyxDQUFDLElBQVosQ0FBaUIsSUFBSyxDQUFBLENBQUEsQ0FBdEIsRUFGRjtHQUFBLE1BR0ssSUFBRyxDQUFJLFFBQVA7SUFDSCxXQUFXLENBQUMsTUFBWixDQUFBLEVBREc7O0VBR0wsSUFBRyxRQUFIOzs7V0FDZSxDQUFFOzs7SUFFZixNQUFNLENBQUMsSUFBUCxDQUFBLEVBSEY7O1NBS0EsSUFBQSxDQUFBO0FBdkMrQjs7QUF5Q2pDLFdBQVcsQ0FBQyxJQUFaLEdBQW1CLFNBQUMsR0FBRCxFQUFzQyxJQUF0QztBQUNqQixNQUFBO0VBRG1CLDJDQUFtQjtFQUN0QyxJQUFPLHlCQUFQO0FBR0UsV0FBTyxJQUFBLENBQUEsRUFIVDs7U0FLQSxDQUFBLENBQUUsU0FBQTtXQUNBLGlCQUFpQixDQUFDLGdCQUFsQixDQUFtQyxTQUFBO2FBQ2pDLENBQUMsQ0FBQyxJQUFGLENBQ0U7UUFBQSxHQUFBLEVBQUssaUJBQWlCLENBQUMsWUFBdkI7UUFDQSxRQUFBLEVBQVUsTUFEVjtRQUVBLE9BQUEsRUFBUyxTQUFDLElBQUQ7VUFDUCxJQUFHLGlCQUFpQixDQUFDLGVBQXJCO21CQUNFLFdBQVcsQ0FBQyxrQkFBWixDQUErQixJQUEvQixFQUFxQyxjQUFyQyxFQUFxRCxpQkFBckQsRUFBd0UsSUFBeEUsRUFERjtXQUFBLE1BQUE7bUJBR0UsV0FBVyxDQUFDLFlBQVosQ0FBeUIsSUFBekIsRUFBK0IsY0FBL0IsRUFBK0MsSUFBL0MsRUFIRjs7UUFETyxDQUZUO1FBUUEsS0FBQSxFQUFPLFNBQUMsR0FBRDtVQUNMLENBQUEsQ0FBRSxxQ0FBRixDQUF3QyxDQUFDLE1BQXpDLENBQUE7VUFDQSxDQUFBLENBQUUsZ0NBQUYsQ0FBbUMsQ0FBQyxNQUFwQyxDQUFBO1VBQ0EsQ0FBQSxDQUFFLHNDQUFGLENBQXlDLENBQUMsTUFBMUMsQ0FBQTtVQUNBLENBQUEsQ0FBRSxrQ0FBRixDQUFxQyxDQUFDLE1BQXRDLENBQUE7VUFDQSxDQUFBLENBQUUsMkJBQUYsQ0FBOEIsQ0FBQyxNQUEvQixDQUFBO2lCQUVBLElBQUEsQ0FBQTtRQVBLLENBUlA7T0FERjtJQURpQyxDQUFuQztFQURBLENBQUY7QUFOaUI7O0FBMkJuQixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
